var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{ref:"myTextEditor",staticClass:"editor",on:{"changeContent":_vm.changeContent},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})}
var staticRenderFns = []

export { render, staticRenderFns }